module.exports = __webpack_public_path__ + "img/can_flag.637c6b90.png";